import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { AnnouncingHeader } from "@/components/AnnouncingHeader/AnnouncingHeader";
import { VerificationStepsEnum } from "../../../../lib/types/runtimeTypes";

import { IDCheckLoopResponse, VerificationService } from "../../../../lib/types/types";
import { logger } from "../../../../lib/utils/logger/logger";
import { IdCheckLoopOnfidoComponent } from "../IdCheckLoopOnfido/IdCheckLoopOnfido";
import IdCheckLoopOnfidoFooter from "../../IdCheckLoopFooter/IdCheckLoopOnfidoFooter";
import { getAndFormatOrderedStepCards } from "../utils/getAndFormatOrderedStepCards";

export interface StepIDCheckLoopOnfidoProps {
  verificationService: VerificationService;
}

const StepIDCheckLoopOnfido = ({ verificationService }: StepIDCheckLoopOnfidoProps) => {
  const verificationResponse = verificationService.verificationResponse as IDCheckLoopResponse;
  const [shouldShowIdCheckLoop, setShouldShowIdCheckLoop] = React.useState(false);

  const initiateIdCheckLoop = () => {
    logger.info("StepIDCheckLoop initiating ID Check Loop");
    verificationService.submitStep(
      VerificationStepsEnum.idCheckLoop,
      verificationService.viewModel,
      verificationService.verificationResponse,
    );
  };

  React.useEffect(() => {
    if (verificationResponse && verificationResponse.sdkToken) {
      setShouldShowIdCheckLoop(true);
    }
  }, [verificationResponse]);

  return (
    <div id="sid-step-id-check-loop" className="sid-l-container">
      {shouldShowIdCheckLoop && (
        <div className="sid-l-space-btm-lg">
          <div role="main">
            <IdCheckLoopOnfidoComponent verificationService={verificationService} />
          </div>
        </div>
      )}

      {!shouldShowIdCheckLoop && (
        <div>
          <div role="main">
            <AnnouncingHeader align="center">
              <FormattedHTMLMessage
                id="step.idCheckLoop.title"
                defaultMessage="Let's verify your identity"
                tagName="h1"
              />
            </AnnouncingHeader>
            <div className="sid-header__subtitle sid-l-horz-center sid-l-space-btm-md">
              <FormattedHTMLMessage
                id="step.idCheckLoop.subtitle"
                defaultMessage="You'll need access to a mobile phone with a camera or computer with a webcam."
              />
            </div>

            <div className="sid-identity-check-steps">
              {getAndFormatOrderedStepCards(verificationService.programTheme)}
            </div>

            <div className="sid-submit sid-l-horz-center sid-l-space-top-md sid-l-space-btm-md">
              <button
                onClick={initiateIdCheckLoop}
                type="button"
                className="sid-btn sid-btn--dark"
                aria-label="submit"
              >
                <FormattedHTMLMessage id="step.idCheckLoop.continue" defaultMessage="Continue" />
              </button>
            </div>
          </div>
          <IdCheckLoopOnfidoFooter verificationService={verificationService} />
        </div>
      )}
    </div>
  );
};

export default StepIDCheckLoopOnfido;
